import { render, staticRenderFns } from "./LivePlayer.vue?vue&type=template&id=7fe7fe03&scoped=true&"
import script from "./LivePlayer.vue?vue&type=script&lang=js&"
export * from "./LivePlayer.vue?vue&type=script&lang=js&"
import style0 from "./LivePlayer.vue?vue&type=style&index=0&id=7fe7fe03&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe7fe03",
  null
  
)

export default component.exports